import { Button } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { CreateUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateUserEntity";
import { UtronUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/UtronUserEntity";
import {
  ADD_PARKER_FORM_STEPS,
  EMAIL_TEMPLATE,
  INPUTS_PROPS,
  UTRON_PLARFORMS
} from "../../../../../enums/Enums";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import SwitchInput from "../../../Inputs/CustomInputs/SwitchInput";
import AddCarsStep from "../Steps/AddCarsStep";
import classes from "../WizardForm.module.css";
import GeneralDetailsStep from "../Steps/GeneralDeatilsStep";
import SelectedFromGmtUserStep from "../Steps/SelectedFromGmtUserStep";
import SummaryStep from "../Steps/SummaryStep";
import UserTypeStep from "../Steps/UserTypeStep";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import * as carActionsService from "../../../../../services/ActionsService/CarActionsService";
import { UserScopeEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserScopeEntity";
import { EmailMessageEntity } from "../../../../../entities/ServicesEntities/UserEntities/EmailMessageEntity";
import { UserAdditionalData } from "../../../../../entities/ServicesEntities/UserEntities/UserAdditionalData";
import AddTokensWithFobStep from "../Steps/AddTokensWithFobStep";
import store from "../../../../../redux/Store";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import {
  showErrorMessage,
  showAddParkerSuccessMessage,
  showEmailAlreadyExist
} from "../../../../../utils/MessagesUtils";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { getScopeIdBySiteId, getCustomerRoleId, getSiteFromSiteId, getSelectionModelByFlatUser } from "../../../../../utils/UsersUtils";
import { showKioskLoginNameAlreadyExist } from "../../../../../utils/MessagesUtils";
import { useSelector } from "react-redux";
import { phoneNumberToSend } from "../../../../../utils/CommonUtils";
import { refreshAllUsersData } from "../../../../../services/ParkerService";
import { refreshSingleUserDataAndExtended } from "../../../../../services/ParkerService";

const AddParkerForm = () => {
  const sites = useSelector((state) => state.user?.sites);
  const roles = useSelector((state) => state.user.initialState.roles);
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const selectedScope = useSelector((state) => state.user?.selectedScope);

  // added
  let scopesIds = useSelector((state) => state.user.currentUsersScopes).map(userScope => userScope.id);
  const [isFobSkipped, setIsFobSkipped] = useState(false); // added
  const showScanFobButton = useSelector((state) => state.common.showScanFobButton);
  const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);
  const assigneOption = useSelector((state) => state.common.assigneOption);

  const AddTokensWithFobStepRef = useRef();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    dialingCode: DEFAULT_DIALING_CODE,
    isPhoneVerified: false,
    isCodeVerified: false,
    isVerifiedFromGmt: false,
    email: "",
    kioskPIN: "",
    kioskLoginName: "",
    notes: "",
    isAcceptedMobileTermsAndPolicies: false,
    isMessagingEnabled: true,
    profilePicture: "",
    app: true,
    userType: "",
    site: 0,
    cars: [],
    token: "",
    fob: "",
    isPaying: false,
    tokens: [],
    carUserTokens: [],
    isStepSubmitted: false,
    fromGmt: false,
    isGmtUser: false,
    exsistUserEntity: null,
    exsistUserIdentityEntity:null,
    selectedSites: selectedSites
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.GENERAL_DETAILS,
    totalSteps: 5,
    isCurrentStepValid: false,
  });

  const resetDefault = () => {
    // clears phone number and reset dialing code default value
    setFormData((formData) => ({
      ...formData,
      [INPUTS_PROPS.PHONE_NUMBER]: "",
      [INPUTS_PROPS.DIALING_CODE]: DEFAULT_DIALING_CODE
    }));
  };

  useEffect(() => {
    return () => {
      // unmount - on close reset assignOption - case site with fob
      store.dispatch(commonActions.setShowScanFobButton(true));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setAssigneOption(null));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    }
  }, []);

  useEffect(() => {
    if (showScanFobButton || stateData.currentStep <= 2) {
      setFormData({ ...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: [] }); // clear car user token
      setFormData({ ...formData, [INPUTS_PROPS.FOB]: "" });
    }
  }, [showScanFobButton]);


  const setIsCurrentStepValid = (boolean) => {
    setStateData({ ...stateData, ["isCurrentStepValid"]: boolean });
  };

  const handleChange = (newProp) => {
    // if (stateData.currentStep === ADD_PARKER_FORM_STEPS.GENERAL_DETAILS && newProp.fromGmt !== undefined) {
    //   if (newProp.fromGmt === false) {
    //     setFormData({
    //       ...formData,
    //       [INPUTS_PROPS.VERIFIED_FROM_GMT]: false,
    //       [INPUTS_PROPS.FROM_GMT]: false,
    //       // [INPUTS_PROPS.PHONE_NUMBER]: "",
    //       // [INPUTS_PROPS.CODE_VERIFIED]: false,
    //       // [INPUTS_PROPS.PHONE_VERIFIED]: false,
    //       ...newProp
    //     });
    //   } else {
    //     setFormData({
    //       ...formData,
    //       [INPUTS_PROPS.VERIFIED_FROM_GMT]: false,
    //       [INPUTS_PROPS.FROM_GMT]: newProp.phoneNumber !== undefined ? false : true,
    //       // [INPUTS_PROPS.PHONE_NUMBER]: "",
    //       // [INPUTS_PROPS.CODE_VERIFIED]: false,
    //       // [INPUTS_PROPS.PHONE_VERIFIED]: false,
    //       ...newProp
    //     });
    //   }
    // } else {
      setFormData({ ...formData, ...newProp });
    // }
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const buildUtronUserObject = () => {
    const {
      firstName,
      lastName,
      profilePicture,
      carUserTokens,
      kioskLoginName,
      kioskPIN,
      notes,
      isAcceptedMobileTermsAndPolicies,
      isMessagingEnabled,
      exsistUserEntity,
      isGmtUser
    } = formData;

    const utronUser = (exsistUserEntity && isGmtUser) ? exsistUserEntity : new UtronUserEntity(0, "");
    const userAdditionalData = (exsistUserEntity && isGmtUser && exsistUserEntity.userAdditionalData?.length > 0) ? exsistUserEntity.userAdditionalData[0] : new UserAdditionalData(0);

    userAdditionalData.kioskLoginName = kioskLoginName === '' ? null : kioskLoginName;
    userAdditionalData.kioskPIN = kioskPIN === '' ? null : kioskPIN;
    userAdditionalData.notes = notes;
    userAdditionalData.isAcceptedMobileTermsAndPolicies = isAcceptedMobileTermsAndPolicies;
    userAdditionalData.isMessagingEnabled = isMessagingEnabled;

    utronUser.firstName = firstName;
    utronUser.lastName = lastName;
    utronUser.image = profilePicture?.split(",")[1];
    utronUser.carUserTokens = carUserTokens
      ?.filter((cut) => cut.token == null && cut.car != null)
      ?.map((cut) => cut.car);
    utronUser.userAdditionalData = [userAdditionalData];

    return utronUser;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    let userToCreate = {};
    let {
      email,
      firstName,
      lastName,
      phoneNumber,
      userType,
      site,
      carUserTokens,
      isGmtUser,
    } = formData;

    // check if the existing useradditional data kioskPIN matches the kioskPIN input
    let isDecryptionNeeded = formData?.exsistUserEntity?.userAdditionalData[0]?.kioskPIN === formData.kioskPIN
    let decryptedKioskPIN; 

    if (isDecryptionNeeded) {
      decryptedKioskPIN = await decryptKioskPINAsync();
    }

    // fix fob
    if (formData.fob === '') {
      formData.fob = null;
    }
    phoneNumber = formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber);

    const utronUser = buildUtronUserObject();

    //Platform
    // const userPlatform = app ? [UTRON_PLARFORMS.MOBILE] : null;

    // const emailTemplateKey = app
    //   ? EMAIL_TEMPLATE.GMT_WELCOME_MAIL_ACTIVE_APP_TEMPLATE_ID
    //   : EMAIL_TEMPLATE.GMT_WELCOME_MAIL_TEMPLATE_ID;

    const userPlatform = [UTRON_PLARFORMS.MOBILE];
    const emailTemplateKey =
      EMAIL_TEMPLATE.GMT_WELCOME_MAIL_TEMPLATE_ID;

    let siteDisplayName = getSiteFromSiteId(sites, site).displayName;


    const emailMessageEntity = new EmailMessageEntity(
      emailTemplateKey,
      JSON.stringify({
        FirstName: firstName,
        LastName: lastName,
        GarageName: siteDisplayName,
        KioskPID: formData.kioskLoginName,
        KioskPIN: isDecryptionNeeded ? decryptedKioskPIN : formData.kioskPIN
      })
    );

    const userScopes = [new UserScopeEntity(
      null,
      getScopeIdBySiteId(sites, site),
      getCustomerRoleId(roles)
    )];

    userToCreate = new CreateUserEntity(
      phoneNumber,
      email,
      userType,
      site,
      userPlatform,
      carUserTokens,
      utronUser,
      emailMessageEntity,
      isGmtUser,
      userScopes
    );

    if (stateData.isCurrentStepValid) {
      let action = null;
      if (isGmtUser) {
        action = actionsService.registerExsistUser(userToCreate, true, false);
      } else {
        action = actionsService.createUser(userToCreate, true, false);
      }

      // TEST - ON success
      // actionsService
      //       .getUserScopes(gmtUser.userIdentity.id)
      //       .then((response) => {
      //         store.dispatch(userActions.setScopes(response.data.entity));
      //       })
      //       .then(() => {
      //         store.dispatch(userActions.setUsersScope(site));
      //         showUpdateSuccessMessage();
      //       });
      //     store.dispatch(userActions.setParkersAndGuests());

      // to be added - scopes
      // action?.then((response) => {

      //   if (response.data.isSuccess) {
      //     store.dispatch(commonActions.closeSideModal());
      //     actionsService
      //       .getUserScopes(gmtUser.userIdentity.id)
      //       .then((response) => {
      //         store.dispatch(userActions.setScopes(response.data.entity));
      //       })
      //       .then(() => {
      //         store.dispatch(userActions.setUsersScope(site));
      //         showAddParkerSuccessMessage();
      //       });
      //     store.dispatch(userActions.setParkersAndGuests());
      //   } else {
      //     showErrorMessage(response.data?.error);
      //   }
      // });

      // prev
      action?.then((response) => {
        if (response.data.isSuccess) {
          store.dispatch(commonActions.closeSideModal());
          const newParkerId = response.data.entity?.utronUser?.id;
          
          actionsService.getUserSites(true, false)
            .then((response) => {
              store.dispatch(userActions.setSites(response.data.entity));
            })
            .then(() => {
              // sets which users to update on the table (sets the currentUsersScopes)
              // later on currentUsersScopes'ids is sended to userIds call on useParkerService
              store.dispatch(userActions.setUsersScope(selectedScope.id));
              
            })
            .then(() => {
              // After success message, fetch new parker data and display in info window
              return refreshSingleUserDataAndExtended(newParkerId, scopesIds);
            })
            .then((response) => {
              if (response.data?.entity?.[0]) {
                let parkerSelectionModel = getSelectionModelByFlatUser(response.data.entity[0], selectedSites);
                showAddParkerSuccessMessage(siteDisplayName);
                store.dispatch(userActions.setParkerSelectionModel(parkerSelectionModel));
                store.dispatch(userActions.setShowUserInfoWindow(true));
              }
              // Refresh all parkers list in the background after info window is displayed
              refreshAllUsersData().catch((error) => {
                console.error('Error refreshing parkers list:', error);
              });
            })
            .catch((error) => {
              console.error('Error in parker creation flow:', error);
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            });
        } else {
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      }).catch((error) => {
        console.error('Error in parker creation flow:', error);
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
      });
    }
  };

  const decryptKioskPINAsync = async () => {   
    try {
      return await actionsService.getDecryptedKioskPIN(formData.kioskPIN, false, false).then(response => response.data.entity);
    }
    catch (err) {
      console.log(err);
    }
  };

  const validatePhoneNumber = () => {
    // checks if the phone number is available to use, (server returns isSucces = false & enitity = null when user not founded)
    // therefore here doin the opposite boolean resolvings
    let phoneNumber = formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber);
    return new Promise((resolve, reject) => {
      if (stateData.currentStep === 1 && phoneNumber !== formData.exsistUserIdentityEntity?.phoneNumber) {
        actionsService.validatePhoneNumber(phoneNumber, true, false)
          .then((response) => {
            if (!response.data.isSuccess && response.data.entity === null ) {
              resolve(true);
            } else if (!response.data.isSuccess) {
              resolve(true);
            }
            else {
              resolve(false);
            }
          }).catch((err) => {
            reject(err);
          })
      } else {
        resolve(true);
      }
    });
  };

  const validateEmail = () => {
    return new Promise((resolve, reject) => {
      if (stateData.currentStep === 1 /*&& !formData.isVerifiedFromGmt*/&& formData.email !== formData.exsistUserIdentityEntity?.email) {
        actionsService.verifyIsEmailOk(formData.email, '')
          .then((response) => {
            if (response.data.isSuccess && response.data.entity === false ) {
              resolve(false);
            } else if (!response.data.isSuccess) {
              resolve(false);
            }
            else {
              resolve(true);
            }
          }).catch((err) => {
            reject(err);
          })
      } else {
        resolve(true);
      }
    });
  };

  const validateLoginName = () => {
    return new Promise((resolve, reject) => {
      if (stateData.currentStep === 1 && formData.kioskLoginName !== formData.exsistUserEntity?.userAdditionalData[0]?.kioskLoginName) {
        if (formData.kioskLoginName === '') {
          resolve(true);
        } else{
            actionsService.verifyIsKioskLoginNameOk(formData.kioskLoginName, '')
            .then((response) => {
              if (response.data.isSuccess && response.data.entity === false ) {
                resolve(false);
              } else if (!response.data.isSuccess) {
                resolve(false);
              }
              else {
                resolve(true);
              }
            }).catch((err) => {
              reject(err);
            })
          }
        } else {
          resolve(true);
        }
      });
    };

  const validateCarDetails = () => {
    return new Promise((resolve, reject) => {
      if (stateData.currentStep === 4 && formData.cars?.length > 0) {
        let car = formData?.cars?.[0];
        if (car.nickname === '' || car.licensePlate === '') {
          resolve({ isValid: true, response: null });
        } else{
            carActionsService.isValidCarDetails(car)
            .then((response) => {
              if (response.data.isSuccess && response.data.entity === false ) {
                resolve({ isValid: false, response: response?.data });
              } else if (!response.data.isSuccess) {
                resolve({ isValid: false, response: response?.data});
              }
              else {
                resolve({ isValid: true, response: null });
              }
            }).catch((err) => {
              reject(err);
            })
          }
        } else {
          resolve({ isValid: true, response: null });
        }
      });
    };
    
  const next = () => {
    let isEmailOk = true;
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    if(stateData.isCurrentStepValid){
      validateEmail().then((response) => {
        isEmailOk = response;
        if (isEmailOk) {
          let isKioskLoginNameOk = true;
          validateLoginName().then((response) => {
            isKioskLoginNameOk = response;
            if (isKioskLoginNameOk) {
              //setFormData({ ...formData, ["isStepSubmitted"]: true });
              let isValidCarDetails = true;
              validateCarDetails().then((response) => {
                isValidCarDetails = response;
                if (isValidCarDetails?.isValid) {
                  if (stateData.isCurrentStepValid) {
                    let currentStep = stateData.currentStep;
                    currentStep =
                      currentStep >= stateData.totalSteps - 1
                        ? stateData.totalSteps
                        : currentStep + 1;
                    setStateData({ ...stateData, currentStep: currentStep });
                    setFormData({ ...formData, ["isStepSubmitted"]: false });
      
                    let selectedSite = sites.find(site => site.id === formData.site);
                    if (stateData.currentStep === ADD_PARKER_FORM_STEPS.USER_TYPE) {
                      // not supported
                      if (!selectedSite?.isFobsSupported) {
                        setIsFobSkipped(true);
                        store.dispatch(commonActions.setShowScanFobButton(false));
                        store.dispatch(commonActions.setShowAssigneFobOptions(true));
                      } else {
                        setIsFobSkipped(false);
                        store.dispatch(commonActions.setShowScanFobButton(true));
                        store.dispatch(commonActions.setShowAssigneFobOptions(false));
                      }
                      store.dispatch(commonActions.setShowFobScannerInput(false));
                      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
                      store.dispatch(commonActions.setAssigneOption(null));
                    }
                  }
                }
                else {
                  setFormData({ ...formData, ["isStepSubmitted"]: false });
                  store.dispatch(commonActions.setIsShowLoadingSpinner(false));
                  showErrorMessage(isValidCarDetails?.response?.error);
                }
              })
              .catch(error => {
                setFormData({ ...formData, ["isStepSubmitted"]: false });
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              });
            } else {
              setFormData({ ...formData, ["isStepSubmitted"]: false });
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              showKioskLoginNameAlreadyExist();
            }
          }).catch(error => {
            setFormData({ ...formData, ["isStepSubmitted"]: false });
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          })
        }
        else {
          setFormData({ ...formData, ["isStepSubmitted"]: false });
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          showEmailAlreadyExist();
        }
      }).catch((error) => {
        setFormData({ ...formData, ["isStepSubmitted"]: false });
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        showErrorMessage(error);
      });
    }
  };

  const prev = () => {
    let selectedSite = sites.find(site => site.id === formData.site);

    // handleBackWithAssigned
    if (stateData.currentStep === 3 && AddTokensWithFobStepRef.current.occupiedTokens.length !== 0) {
      store.dispatch(commonActions.setShowScanFobButton(false));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(true));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      store.dispatch(commonActions.setAssigneOption(null));
      AddTokensWithFobStepRef.current.setOccupiedTokens([]); // clears token display
      setFormData({ ...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: [] });
    } else if ((stateData.currentStep === 3 || stateData.currentStep === 4) && assigneOption === 2) {
      store.dispatch(commonActions.setShowScanFobButton(false));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(true));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      store.dispatch(commonActions.setAssigneOption(null));
      AddTokensWithFobStepRef.current.setOccupiedTokens([]); // clears token display

      // setFormData({...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: []});
      // handleChange({ [INPUTS_PROPS.FOB]: "" });
    } else {
      //setIsFobSkipped(false); // added

      // reset back to initial Step 3 Form state

      // not supported
      if (!selectedSite?.isFobsSupported) {
        setIsFobSkipped(true);
        store.dispatch(commonActions.setShowScanFobButton(false));
        store.dispatch(commonActions.setShowFobScannerInput(false));
      } else {
        setIsFobSkipped(false);
        store.dispatch(commonActions.setShowScanFobButton(true));
        store.dispatch(commonActions.setShowFobScannerInput(false));
        // setFormData({ ...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: [] }); // clear car user token
        // setFormData({ ...formData, [INPUTS_PROPS.FOB]: "" });
      }
      store.dispatch(commonActions.setShowAssigneFobOptions(false));

      /*
      store.dispatch(commonActions.setShowScanFobButton(true));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      */

      if (stateData.currentStep === 4) {
        // not supported
        if (!selectedSite?.isFobsSupported) {
          setIsFobSkipped(true);
          store.dispatch(commonActions.setShowScanFobButton(false));
          store.dispatch(commonActions.setShowFobScannerInput(false));
        } else {
          setIsFobSkipped(false);
          store.dispatch(commonActions.setShowScanFobButton(false));
          store.dispatch(commonActions.setShowFobScannerInput(false));

        }
        store.dispatch(commonActions.setShowAssigneFobOptions(false));
      }



      // setFormData({...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: []}); // clear car user token
      // setFormData({...formData, [INPUTS_PROPS.FOB]: ""});

      let currentStep = stateData.currentStep;
      currentStep = currentStep <= 1 ? 1 : showScanFobButton === true || currentStep === 4 || !selectedSite?.isFobsSupported ? currentStep - 1 : currentStep;
      setStateData({ ...stateData, currentStep: currentStep });
    }

    // added - when clicking back in all cases clear selection
    store.dispatch(commonActions.setAssigneOption(null));
    // setFormData({...formData, [INPUTS_PROPS.CAR_USER_TOKEN]: []});
    // setFormData({...formData, [INPUTS_PROPS.FOB]: ""});
    setFormData({ ...formData, ["isStepSubmitted"]: false }); // added
  };

  return (
    <>
      {stateData.currentStep !== 1 && (
        <div className={classes.prev}>
          <img src={Icons.LEFT_ARROW} />
          <Button onClick={prev}>Back</Button>
        </div>
      )}

      <div className={classes.formContainer}>
        {stateData.currentStep === ADD_PARKER_FORM_STEPS.GENERAL_DETAILS && (
          <div className={classes.gmtUserSelection}>
            <SwitchInput
              checked={formData.fromGmt}
              onChange={handleChange}
              resetDefault={resetDefault}
              leftChecked={true}
              disabled={formData.isGmtUser}
              leftText={"New Parker"}
              rightText={"From GMT"}
              id={INPUTS_PROPS.FROM_GMT}
              {...formData}
            />
          </div>
        )}
        <form name="AddParker" onSubmit={handleSubmit}>
          {formData.fromGmt  && !formData.isPhoneVerified  && (
            <SelectedFromGmtUserStep
              handleChange={handleChange}
              handleCurrentStepValidity={handleCurrentStepValidity}
              currentStep={stateData.currentStep}
              {...formData}
            />
          )}
          {(!formData.fromGmt || (formData.fromGmt && formData.isPhoneVerified)) && (
            <GeneralDetailsStep
              handleChange={handleChange}
              handleCurrentStepValidity={handleCurrentStepValidity}
              currentStep={stateData.currentStep}
              {...formData}
            />
          )}
          <UserTypeStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            {...formData}
          />
          {/* <AddTokensFromListStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            selectedSite={getSiteFromSiteId(sites, formData.site)}
            {...formData}
          /> */}
          <AddTokensWithFobStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            setIsCurrentStepValid={setIsCurrentStepValid} // added
            isFobSkipped={isFobSkipped} // added 
            setIsFobSkipped={setIsFobSkipped} // added 
            ref={AddTokensWithFobStepRef} // added
            selectedSite={getSiteFromSiteId(sites, formData.site)} // added
            totalSteps={stateData.totalSteps}
            {...formData}
          />
          <AddCarsStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            isTokenVerified={true}
            defaultCarTokenId={formData?.cars[0]?.token?.value}
            isFobSkipped={isFobSkipped}
            totalSteps={stateData.totalSteps}
            {...formData}
          />
          <SummaryStep currentStep={stateData.currentStep} {...formData} />
          {(!formData.fromGmt || (formData.fromGmt && formData.isPhoneVerified)) && stateData.currentStep < stateData.totalSteps && (stateData.currentStep <= 2 || formData.carUserTokens?.length !== 0) && !showExsistingParkingAllocation && (
            <div className={classes.next}>
              <EllipseButton onClick={next}>{Strings.NEXT}</EllipseButton>
            </div>
          )}

          {stateData.currentStep == stateData.totalSteps && (
            <div className={classes.next}>
              <EllipseButton type="submit">{Strings.ADD_PARKER}</EllipseButton>
            </div>
          )}
        </form>
      </div>
    </>
  );
};

export default AddParkerForm;
